<div class="graphs-boundaries" cdkDropListGroup>
  <div class="graph-placeholder" cdkDropList [cdkDropListEnterPredicate]="enter" (cdkDropListDropped)="drop()" #placeholder></div>
  <div *ngFor="let gridItem of gridItems; index as idx" id="graph-{{idx}}" class="graph {{resizeTable[idx]}}" cdkDropList [cdkDropListEnterPredicate]="enter" [cdkDropListDisabled]="isDisabled" (cdkDropListDropped)="drop()">
    <div class="backgroundWhiteRound graph-container {{resizeTable[idx]}}-container" (cdkDragMoved)="dragMoved($event)" cdkDrag>
      <ng-template [ngTemplateOutlet]="gridItem.templateRef"></ng-template>
      <div class="graph-handle" cdkDragHandle>
        <img src="assets/stats/handle.svg" alt="" />
      </div>
      <div class="graph-resizer graph-enlarge" (click)="resizeItem(idx, ResizeType.SWAP)">
        <img src="assets/stats/enlarge.svg" alt="" />
      </div>
      <div class="graph-resizer graph-reduce" (click)="resizeItem(idx, ResizeType.SWAP)">
        <img src="assets/stats/reduce.svg" alt="" />
      </div>
      <div class="graph-close" (click)="closeItem(idx)">
        <img src="assets/stats/close.svg" alt="" />
      </div>
    </div>
  </div>
</div>
